<template>
  <div>
    <h3 :class="{ passed: userPictureFulfilled }">6. ID Card</h3>

    <p>We need a recent picture of your government issued identity card, or passport.</p>

    <div v-if="webcamAccessFulfilled && !userPictureFulfilled">
      <p>
        Please hold your ID along with your face in front of the webcam, then click "take picture" to take a
        picture
      </p>
    </div>

    <div v-if="!webcamAccessFulfilled">
      <p>You should turn on your webcam first and give it requred access in order to take pictures</p>
    </div>

    <div>
      <div>
        <span v-if="userPictureFulfilled">
          <span>Expires in {{ userPictureCountDown }} minutes. </span>
        </span>

        <span>
          <button @click="takeShot">
            <span v-if="!userPictureFulfilled">take picture</span>
            <span v-if="userPictureFulfilled">take picture AGAIN</span>
          </button>
        </span>
      </div>
      <canvas style="width: 50%;" id="user_picture_webcam_canvas"></canvas>
    </div>
    <div>
      <video style="width: 50%;" id="user_picture_webcam_video"></video>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getWebcamStream } from '../../plugins/webcam'

export default {
  data() {
    return {
      video: null
    }
  },
  computed: {
    ...mapGetters('invigilate', ['webcamAccessFulfilled', 'userPictureFulfilled', 'userPictureCountDown']),
    ...mapState('invigilate', ['user_picture'])
  },

  methods: {
    async takeShot() {
      try {
        const canvas = document.getElementById('user_picture_webcam_canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = this.video.videoWidth
        canvas.height = this.video.videoHeight
        ctx.drawImage(this.video, 0, 0)
        let dataUrl = canvas.toDataURL('image/jpeg')
        this.$store.dispatch('invigilate/setUserPicture', dataUrl)
      } catch (error) {
        console.log("Error taking user's picture")
        console.log(error)
      }
    }
  },

  watch: {
    user_picture(value) {
      if (value === null) {
        let canvas = document.getElementById('user_picture_webcam_canvas')
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
      }
    }
  },

  async mounted() {
    let { stream } = await getWebcamStream({ quality: 'high' })
    this.video = document.getElementById('user_picture_webcam_video')
    this.video.srcObject = stream
    await this.video.play()

    // get user picture from browser storage if exist
    if (this.userPictureFulfilled) {
      let canvas = document.getElementById('user_picture_webcam_canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.onload = function() {
        canvas.width = this.width
        canvas.height = this.height
        ctx.drawImage(img, 0, 0)
      }
      img.src = this.user_picture
    }
  }
}
</script>
